/**
 * Convert a string to sentence case.
 * @example - toSentenceCase('BROOMEHILL-TAMBELLUP') => 'Broomehill-Tambellup'
 * @param str
 * @returns
 */
export const toTitleCase = (str: string, separator: string = '-'): string => {
  // Can take undefined values
  if (!str) return '';
  return str
    .split(separator)
    .map((part) =>
      part
        .split(' ')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join(' ')
    )
    .join('-');
};
